(() => {
  const mobile = matchMedia('(max-width: 768.98px)');
  let previousY = scrollY;
  let queued = false;
  function updateHeader() {
    const header = document.querySelector('store-header');
    const section = header?.closest('.shopify-section');
    if (!section) return;
    const y = Math.max(0, scrollY);
    if (!mobile.matches) {
      section.classList.remove('sbs-mobile-header-hidden');
      document.documentElement.style.removeProperty('--mobile-header-offset');
    } else {
      const interacting = header.contains(document.activeElement) || document.body.classList.contains('fixed') || header.querySelector('[aria-expanded="true"]');
      if (y < 100 || interacting || y < previousY - 5) section.classList.remove('sbs-mobile-header-hidden');
      else if (y > previousY + 5) section.classList.add('sbs-mobile-header-hidden');
      const visible = !section.classList.contains('sbs-mobile-header-hidden');
      document.documentElement.style.setProperty('--mobile-header-offset', `${visible ? section.offsetHeight : 0}px`);
    }
    if (Math.abs(y - previousY) > 5) previousY = y;
  }
  function alignRows() {
    document.querySelectorAll('.main-products-grid__results > .grid').forEach((grid) => {
      const slots = [...grid.querySelectorAll('.card__options-slot')];
      slots.forEach(slot => { slot.style.minHeight = ''; slot.classList.remove('sbs-options-empty'); });
      if (!mobile.matches) return;
      const rows = new Map();
      [...grid.children].forEach(item => {
        const slot = item.querySelector('.card__options-slot');
        if (!slot) return;
        const top = Math.round(item.getBoundingClientRect().top);
        if (!rows.has(top)) rows.set(top, []);
        rows.get(top).push(slot);
      });
      rows.forEach(row => {
        const hasContent = slot => [...slot.children].some(child => child.getBoundingClientRect().height > 0 && getComputedStyle(child).display !== 'none');
        const active = row.filter(hasContent);
        if (!active.length) row.forEach(slot => slot.classList.add('sbs-options-empty'));
        else {
          const height = Math.max(...active.map(slot => slot.getBoundingClientRect().height));
          row.forEach(slot => { slot.style.minHeight = `${height}px`; });
        }
      });
    });
  }
  function scheduleRows() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; alignRows(); });
  }
  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', () => { updateHeader(); scheduleRows(); });
  document.addEventListener('focusin', updateHeader);
  document.addEventListener('change', scheduleRows);
  new MutationObserver(scheduleRows).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('load', scheduleRows, true);
  updateHeader();
  scheduleRows();
})();
